import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

declare var bootstrap: any;

@Component({
  selector: 'app-reatiler-order-list',
  templateUrl: './reatiler-order-list.component.html',
  styleUrls: ['./reatiler-order-list.component.scss'],
  standalone: false
  
})
export class ReatilerOrderListComponent implements OnInit {
  btn: any = "Pending";
  headingName: any = 'Order Management';
  linkerRouteItems: any = [
    { name:'Home',route: '/home'},
    {name:'Account',route:'/customer-profile'},
    {name:'Order History',route:'/retailer-order-list'}
  ];
  orderList: any = [];
  count: any;
  pendingCount: any = 0;
  deliveredCount: any = 0;
  currentPage: any = 1;
  pageSize: any = 10;
  serviceStatus: any = 'PENDING';
  isLoading:boolean = false;
  totalOrderPrice: number = 0;
  notFoundData:boolean = false;

  // Selected order for return request modal
  selectedOrder: any;

  constructor(public commonService: CommonService, public router: Router) { }

  ngOnInit(): void {
    this.serviceOrderList();
    this.loadAllCounts();
  }

  loadAllCounts() {
    // Load pending count
    const pendingData = {
      page: 1,
      limit: 1,
      orderType: 'PRODUCT',
      deliveredStatus: 'PENDING'
    };
    this.commonService.postApi('order/v2/retailerOrderList', pendingData, 1).subscribe((res: any) => {
      if (res['responseCode'] == 200) {
        this.pendingCount = res.result.count || 0;
      }
    });

    // Load delivered count
    const deliveredData = {
      page: 1,
      limit: 1,
      orderType: 'PRODUCT',
      deliveredStatus: 'DELIVERED'
    };
    this.commonService.postApi('order/v2/retailerOrderList', deliveredData, 1).subscribe((res: any) => {
      if (res['responseCode'] == 200) {
        this.deliveredCount = res.result.count || 0;
      }
    });
  }

  selectBtn(status) {
    this.btn = status;
    this.notFoundData = false;
    this.serviceStatus = (this.btn == 'Pending') ? 'PENDING' : 'DELIVERED';
    this.serviceOrderList();
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e);
  }

  serviceOrderList() {
    this.isLoading = true;
    this.orderList = [];
    this.count = 0;
    const data = {
      page: this.currentPage,
      limit: this.pageSize,
      orderType: 'PRODUCT',
      deliveredStatus: this.serviceStatus
    };
    this.commonService.postApi('order/v2/retailerOrderList', data, 1).subscribe((res: any) => {
      this.isLoading = false;
      if (res['responseCode'] == 200) {
        this.commonService.hideSpinner();
        this.orderList = res.result.docs;
        this.notFoundData = (res.result.docs.length === 0);
        this.count = res.result.count;
        // Update the respective count based on current status
        if (this.serviceStatus === 'PENDING') {
          this.pendingCount = res.result.count;
        } else if (this.serviceStatus === 'DELIVERED') {
          this.deliveredCount = res.result.count;
        }
        this.totalOrderPrice = this.getTotalOrderPrice(this.orderList);
      }
    }, (err: any) => {
      this.notFoundData = true;
      this.isLoading = false;
      this.orderList = [];
      if (err.responseCode == 409) {
        this.commonService.hideSpinner();
        this.commonService.errorToast(err.responseMessage);
      }
    });
  }

  changePageNumber(page) {
    this.currentPage = page;
    this.serviceOrderList();
  }

  getTotalOrderPrice(myOrders: any[]): number {
    let totalPrice = 0;
    if (myOrders && Array.isArray(myOrders)) {
      myOrders.forEach(myOrder => {
        if (myOrder && myOrder.price) totalPrice += myOrder.price;
      });
    }
    return totalPrice;
  }

  // ✅ Open Return Request Modal
  openReturnRequestModal(order) {
    this.selectedOrder = order;
    new bootstrap.Modal(document.getElementById('returnRequestModal')).show();
  }

  // ✅ Add inside your ReatilerOrderListComponent class
getPaymentStatus(item: any): string {
  if (item?.returnRequests?.some(r => r.status === 'APPROVED')) return 'APPROVED';
  if (item?.returnRequests?.some(r => r.status === 'DECLINED')) return 'DECLINED';
if (item?.returnRequests?.some(r => r.status === 'PENDING')) return 'RETURN REQUESTED PENDING';
  return item?.paymentStatus;
}

getPaymentClass(item: any): string {
  if (item?.returnRequests?.some(r => r.status === 'APPROVED')) return 'green-color';
  if (item?.returnRequests?.some(r => r.status === 'DECLINED')) return 'red-color';
  if (item?.returnRequests?.some(r => r.status === 'RETURN REQUESTED PENDING')) return 'red-color';
  if (!item?.returnRequests?.length && item?.paymentStatus === 'COMPLETED') return 'green-color';
  return 'red-color';
}


  // ✅ Update return request status
updateReturnStatus(orderId: string, returnRequestId: string, status: string) {
    const payload = { orderId, returnRequestId, status };
    this.commonService.postApi('order/updateReturnRequestStatus', payload, 1).subscribe(
      (res: any) => {
        if(res.success){
          this.commonService.successToast(res.message);

          // ✅ Update the frontend orderList dynamically without removing items
          const orderIndex = this.orderList.findIndex(o => o._id === orderId);
          if(orderIndex !== -1 && this.orderList[orderIndex].returnRequests){
            this.orderList[orderIndex].returnRequests = this.orderList[orderIndex].returnRequests.map(r =>
              r._id === returnRequestId ? { ...r, status: status } : r
            );

            // If no return requests left, optionally update paymentStatus to COMPLETED
            if (!this.orderList[orderIndex].returnRequests.length && status === 'APPROVED') {
              this.orderList[orderIndex].paymentStatus = 'COMPLETED';
            }
          }

          this.selectedOrder = null;
          bootstrap.Modal.getInstance(document.getElementById('returnRequestModal'))?.hide();
        } else {
          this.commonService.errorToast(res.message);
        }
      }, err => {
        this.commonService.errorToast('Something went wrong!');
      }
    );
  }
}